(() => {
  const findDialog = (id) => document.getElementById(id);

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-quick-add-open]');
    if (opener) {
      findDialog(opener.dataset.quickAddOpen)?.showModal();
      return;
    }

    const closer = event.target.closest('[data-quick-add-close]');
    if (closer) {
      closer.closest('dialog')?.close();
    }
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-quick-add-select]')) return;
    const submit = event.target.form?.querySelector('[data-quick-add-submit]');
    if (submit) submit.disabled = !event.target.value;
  });

  document.querySelectorAll('[data-quick-add-dialog]').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  const storageKey = 'pulsokage-recently-viewed';
  document.querySelectorAll('[data-recently-viewed]').forEach((section) => {
    const dataNode = section.querySelector('[data-recent-current]');
    const grid = section.querySelector('[data-recent-grid]');
    if (!dataNode || !grid) return;

    let current;
    let history = [];
    try {
      current = JSON.parse(dataNode.textContent);
      history = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(history)) history = [];
    } catch (error) {
      return;
    }

    const visibleItems = history
      .filter((item) => String(item.id) !== String(current.id))
      .slice(0, Number(section.dataset.recentLimit || 4));

    visibleItems.forEach((item) => {
      const article = document.createElement('article');
      article.className = 'pk-recently-viewed__card';

      const mediaLink = document.createElement('a');
      mediaLink.className = 'pk-recently-viewed__media';
      mediaLink.href = item.url;
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.title;
        image.loading = 'lazy';
        mediaLink.appendChild(image);
      }

      const title = document.createElement('h3');
      const titleLink = document.createElement('a');
      titleLink.href = item.url;
      titleLink.textContent = item.title;
      title.appendChild(titleLink);

      const price = document.createElement('p');
      price.textContent = item.price;

      article.append(mediaLink, title, price);
      grid.appendChild(article);
    });

    if (visibleItems.length) section.hidden = false;

    const updatedHistory = [
      current,
      ...history.filter((item) => String(item.id) !== String(current.id))
    ].slice(0, 12);

    try {
      localStorage.setItem(storageKey, JSON.stringify(updatedHistory));
    } catch (error) {
      // Browsing remains functional when storage is unavailable.
    }
  });
})();
